import React, { useState, useEffect } from "react";
import { collection, getDocs, doc, deleteDoc } from "firebase/firestore";
import db from "./Firebase"; // your firebase config file
import Swal from "sweetalert2";

const FunderUsersListPage = () => {
    const [users, setUsers] = useState([]);
    const [selected, setSelected] = useState({}); // map of id -> boolean (checked)
    const [selectAll, setSelectAll] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const colRef = collection(db, "funder_users_list");
            const snap = await getDocs(colRef);
            const data = snap.docs.map(docSnap => ({
                id: docSnap.id,
                ...docSnap.data()
            }));
            setUsers(data);
            // Reset selection
            const sel = {};
            data.forEach(u => {
                sel[u.id] = false;
            });
            setSelected(sel);
            setSelectAll(false);
        } catch (err) {
            console.error("Error fetching funder users:", err);
            Swal.fire("Error", "Could not load users", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleSelectAll = (e) => {
        const checked = e.target.checked;
        const newSel = {};
        users.forEach(u => {
            newSel[u.id] = checked;
        });
        setSelected(newSel);
        setSelectAll(checked);
    };

    const handleSelectOne = (id, e) => {
        const checked = e.target.checked;
        setSelected(prev => ({
            ...prev,
            [id]: checked
        }));
    };

    const handleDeleteSelected = async () => {
        const toDeleteIds = users.filter(u => selected[u.id]).map(u => u.id);
        if (toDeleteIds.length === 0) {
            Swal.fire("Info", "No user selected for deletion", "info");
            return;
        }

        const confirm = await Swal.fire({
            title: `Delete ${toDeleteIds.length} user(s)?`,
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete",
            cancelButtonText: "Cancel"
        });

        if (!confirm.isConfirmed) {
            return;
        }

        try {
            for (let id of toDeleteIds) {
                await deleteDoc(doc(db, "funder_users_list", id));
            }
            Swal.fire("Deleted", `${toDeleteIds.length} users deleted`, "success");
            // Refresh
            fetchUsers();
        } catch (err) {
            console.error("Delete error:", err);
            Swal.fire("Error", "Failed to delete some users", "error");
        }
    };

    return (
        <div className="container py-4">
            <h2>Funder Users List</h2>
            {loading ? (
                <p>Loading...</p>
            ) : (
                <>
                    <div className="mb-2">
                        <button className="btn btn-danger" onClick={handleDeleteSelected}>
                            Delete Selected
                        </button>
                    </div>
                    <table className="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>
                                    <input
                                        type="checkbox"
                                        style={{ display: "block" }}
                                        checked={selectAll}
                                        onChange={handleSelectAll}
                                    />
                                </th>
                                <th>Phone No</th>
                                <th>Name</th>
                                <th>Username</th>
                                <th>State</th>
                                <th>City</th>
                                <th>Type</th>
                                <th>Age Range</th>
                                {/* Add more headers if needed */}
                            </tr>
                        </thead>
                        <tbody>
                            {users.length === 0 ? (
                                <tr>
                                    <td colSpan={8} className="text-center">No data found</td>
                                </tr>
                            ) : (
                                users.map((u, index) => (
                                    <tr key={u.id}>
                                        <td>{index + 1}</td> {/* Show index starting from 1 */}
                                        <td>
                                            <input
                                                type="checkbox"
                                                style={{ display: "block" }}
                                                checked={!!selected[u.id]}
                                                onChange={(e) => handleSelectOne(u.id, e)}
                                            />
                                        </td>
                                        <td>{u.phone_no || u.phone}</td>
                                        <td>{u.name}</td>
                                        <td>{u.username}</td>
                                        <td>{u.state}</td>
                                        <td>{u.city}</td>
                                        <td>{u.type}</td>
                                        <td>{u.age_range}</td>
                                    </tr>
                                ))

                            )}
                        </tbody>
                    </table>
                </>
            )}
        </div>
    );
};

export default FunderUsersListPage;
